import {
  FETCH_MEAL_PULL_LIST,
  FETCH_MEAL_PULL_LIST_SUCCESS,
  FETCH_MEAL_PULL_LIST_FAILURE,
  ACKNOWLEDGE_MEAL_PROFILE,
  DOWNLOAD_MEAL_PULL_LIST_PDF,
  DOWNLOAD_MEAL_PULL_LIST_PDF_SUCCESS,
  DOWNLOAD_MEAL_PULL_LIST_PDF_FAILURE,
} from "./constants";

export const fetchMealPullList = (payload) => ({
  type: FETCH_MEAL_PULL_LIST,
  payload,
});
export const fetchMealPullListSuccess = (payload) => ({
  type: FETCH_MEAL_PULL_LIST_SUCCESS,
  payload,
});
export const fetchMealPullListFailure = () => ({
  type: FETCH_MEAL_PULL_LIST_FAILURE,
});

export const acknowledgeMealProfile = (payload) => ({
  type: ACKNOWLEDGE_MEAL_PROFILE,
  payload,
});

export const downloadMealPullListPdf = (payload, onDone) => ({
  type: DOWNLOAD_MEAL_PULL_LIST_PDF,
  payload,
  onDone,
});
export const downloadMealPullListPdfSuccess = () => ({
  type: DOWNLOAD_MEAL_PULL_LIST_PDF_SUCCESS,
});
export const downloadMealPullListPdfFailure = () => ({
  type: DOWNLOAD_MEAL_PULL_LIST_PDF_FAILURE,
});
